import initialState from './initialState'
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as getAllBonificationReducer } from './getAllBonification/reducer'
import { reducer as addBonifications } from './addBonifications/reducer'
import { reducer as updateBonifications } from './updateBonifications/reducer'
import { reducer as setDisabledBoxAlert } from './setDisabledBoxAlert/reducer'
import { reducer as getAllConventionalBonificationsByVersions } from './getAllConventionalBonificationsByVersions/reducer'
import { reducer as cleanBonifications } from './cleanBonifications/reducer'
import { reducer as updateConventionalIndividualBonifications } from './updateConventionalIndividualBonifications/reducer'
import { reducer as getRoles } from './getRoles/reducer'
import { reducer as getRoleBonifications } from './getRoleBonifications/reducer'
import { reducer as saveRolesBonifications } from './saveRolesBonifications/reducer'
import { reducer as cleanRolesBonifications } from './cleanRolesBonifications/reducer'
import { reducer as setDataFilterSelected } from './setDataFilterSelected/reducer'
import { reducer as setVin } from './setVin/reducer'

const reducers = [
  getAllBonificationReducer,
  addBonifications,
  updateBonifications,
  setDisabledBoxAlert,
  getAllConventionalBonificationsByVersions,
  updateBonifications,
  cleanBonifications,
  updateConventionalIndividualBonifications,
  getRoles,
  getRoleBonifications,
  saveRolesBonifications,
  cleanRolesBonifications,
  setDataFilterSelected,
  setVin,
];

export default function reducer(state = initialState, action = {}) {
  let newState;
    if (action.type === LOGOUT_USER) {
      // Handle cross-topic actions here
        newState = initialState;
    }
    else {
      newState = state;
    }
  return reducers.reduce((s, r) => r(s, action), newState);
}
